import { setToken } from '@/utils/auth';
import localFun from '@/utils/local-ope';

const ThemeKey = 'h5-theme';
export const DefaultThemeColor = '#1AB370';

export const getH5Theme = () => {
  const theme = localFun.get(ThemeKey);
  return theme || DefaultThemeColor;
};
export const getIsWindowWechat = () => {
  const isWechatWindow = localFun.get('h5-isWechatWindow');
  return JSON.parse(isWechatWindow) || false;
};

export const getPermissionCodes = () => {
  const permissionCodes = localFun.get('h5-permissionCodes');
  return permissionCodes || '';
};

function getQueryParams() {
  const href = window.location.href;
  const search = href.split('?')[1];
  const params = new URLSearchParams(`?${search}`);
  //console.log('Params:', params);
  const token = params.get('token');
  //const appId = params.get('appId');
  const theme = params.get('theme');
  const orgId = params.get('orgId');

  const pageFrom = params.get('pageFrom');

  const customerId = params.get('customerId');
  const customerSysCode = params.get('customerSysCode');
  const orgSysCode = params.get('orgSysCode');
  const isSale = params.get('isSale');
  const isWechartWindow = params.get('isPcWechart');
  const permissionCodes = params.get('permissionCodes');

  if (token) {
    // 设置小程序环境，不设置生产环境有问题，临时处理
    window.__wxjs_environment === 'miniprogram';
    setToken(token);
  }
  if (theme) {
    localFun.set(ThemeKey, theme);
  }
  if (orgId) {
    localFun.set('h5-orgId', orgId);
  }
  if (customerId) {
    localFun.set('h5-customerId', customerId);
  }
  if (orgSysCode) {
    localFun.set('h5-orgSysCode', orgSysCode);
  }
  if (customerSysCode) {
    localFun.set('h5-customerSysCode', customerSysCode);
  }
  if (pageFrom) {
    localFun.set('h5-pageFrom', pageFrom);
  }
  if (isWechartWindow) {
    localFun.set('h5-isWechatWindow', isWechartWindow);
  }
  if (permissionCodes) {
    localFun.set('h5-permissionCodes', permissionCodes);
  }

  localFun.set('h5-isSale', isSale);
}
getQueryParams();
